import React from 'react';
import PropTypes from 'prop-types';
import AddressItem from './AddressItem';

const _AddressList = ({ addresses, onSelectAddress, isLoading }) => (
  <div className="dropdown dropdown--address dropdown--fullwidth expanded">
    <div className="dropdown__absolute-container">
      <div className="dropdown__options dropdown__options--menu" key="options">
        {addresses.length > 0
          ? addresses.map((address) => (
              <AddressItem
                key={address.id}
                id={address.id}
                text={address.text}
                description={address.description}
                type={address.type}
                highlight={address.highlight}
                onClick={onSelectAddress}
              />
            ))
          : isLoading && <AddressItem text="Loading..." />}
      </div>
    </div>
  </div>
);

_AddressList.propTypes = {
  addresses: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      highlight: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired
    })
  ),
  onSelectAddress: PropTypes.func.isRequired
};

_AddressList.defaultProps = {
  addresses: []
};

export default _AddressList;
